var viewer_caption_rtlignore_default = {
  "fontElementMap": "Lkjqc",
  "imageCaption": "SeGyV"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
